module.exports = __webpack_public_path__ + "img/user-female.b702632c.png";